import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getDrugsPhyto.success: {
            return action.payload;
        }

        case constants.getDrugsPhyto.error: {
            return initialState;
        }

        case constants.getDrugsPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}